import { Injectable } from '@angular/core';
import { RouteConfigurationBaseService } from './route-configuration-base.service';
import { TransactionRouteConfigurationService } from './transaction-route-configuration.service';

@Injectable()
/**
 * Factory service for getting route configurations
 */
export class RouteConfigurationFactory {

    private services: RouteConfigurationBaseService[];

    constructor(
        private transactionRouteConfigurationService: TransactionRouteConfigurationService
    ) {
        this.services = [];
        this.services.push(transactionRouteConfigurationService);
    }

    /**
     * Get the route configuration service
     */
    public create(): RouteConfigurationBaseService {
        return this.services[0];
    }
}
